import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiCheckboxComponent } from './checkbox/ui-checkbox.component';

@NgModule({
  declarations: [UiCheckboxComponent],
  imports: [CommonModule],
  exports: [UiCheckboxComponent]
})
export class UiModule {}
